var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.selectedRunner
        ? _c("div", { staticClass: "mb-2 appointed_block" }, [
            _c("p", [_vm._v("Выбран курьер для назначения заявок")]),
            _vm._v(" "),
            _c("div", { staticClass: "flex justify-content-between" }, [
              _c("div", [
                _c("p", [_c("strong", [_vm._v(_vm._s(_vm.runnerName))])]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("количество выбранных заявок: "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.selectedOrders.orders.length)),
                  ]),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("на общую сумму: "),
                  _c("strong", [_vm._v(_vm._s(_vm.selectedOrders.totalSum))]),
                ]),
              ]),
              _vm._v(" "),
              _vm.selectedOrders.orders.length
                ? _c(
                    "div",
                    [
                      _c("LoadingButton", {
                        attrs: {
                          title: "Назначить",
                          className: "btn btn-xs btn-success",
                          loading: _vm.btnLoading,
                          color: _vm.$constants.LOADING_COLOR,
                          onClick: () => _vm.appointOrders(),
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.orders, function (o) {
        return o.is_active !== 0
          ? _c("div", { staticClass: "card hover" }, [
              _c("div", { staticClass: "card-body p-2" }, [
                _c("div", { staticClass: "flex justify-content-between" }, [
                  _c(
                    "div",
                    { staticClass: "flex align-items-center" },
                    [
                      _c("span", { staticClass: "badge badge-info mr-1" }, [
                        _vm._v(_vm._s(_vm.moment(o.delivery_date, "DD.MM"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-popover",
                        { attrs: { "auto-hide": true } },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-xs btn-outline-success mr-1",
                              attrs: { type: "button" },
                            },
                            [_vm._v("\n              Перенос\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "template",
                            { slot: "popover" },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: o.new_delivery_date,
                                      expression: "o.new_delivery_date",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        o,
                                        "new_delivery_date",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(
                                  _vm.getChangeDateOptions(o.delivery_date),
                                  function (date) {
                                    return _c(
                                      "option",
                                      {
                                        key: date.date,
                                        domProps: { value: date.date },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(date.text) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                              _vm._v(" "),
                              _c("LoadingButton", {
                                attrs: {
                                  title: "Сохранить",
                                  className: "btn btn-xs btn-success",
                                  loading: _vm.updateBtnLoading,
                                  color: _vm.$constants.LOADING_COLOR,
                                  onClick: () => _vm.updateDeliveryDate(o),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("strong", { staticClass: "mr-1" }, [
                        _vm._v(_vm._s(_vm.mixinPrintOrderNum(o.id))),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$AllProjects[o.site_id]?.name ?? "не определен"
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.moment(o.created_at, "DD.MM"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex justify-content-between" }, [
                  _c(
                    "div",
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            o.client_name ?? o?.client?.name ?? "Имя не указано"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        o.order_phones?.length
                          ? o.order_phones
                          : o.phones.map((p) => {
                              return {
                                ...p,
                                phone: {
                                  phone: ("" + p.full_phone).substring(2),
                                },
                              }
                            }),
                        function (phone) {
                          return [
                            phone.phone
                              ? _c("p", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "phone_num",
                                      attrs: {
                                        href: `tel:${_vm.mixinPrintPhone(
                                          "00" + phone.phone.phone,
                                          true
                                        )}`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.mixinPrintPhone(
                                            "00" + phone.phone.phone
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-xs btn-outline-warning",
                        on: {
                          click: function ($event) {
                            return _vm.noAnswerPhoneCall(o.id, "")
                          },
                        },
                      },
                      [
                        _vm._v("\n            Недозвон "),
                        o.extra_options.noAnswerCallOrder
                          ? _c("span", [
                              _vm._v(
                                "(" +
                                  _vm._s(o.extra_options.noAnswerCallOrder) +
                                  ")"
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-1" },
                  [
                    _c("p", [_vm._v(_vm._s(o.address))]),
                    _vm._v(" "),
                    o.extra_options.address_details
                      ? _c("p", [
                          _vm._v(_vm._s(o.extra_options.address_details)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("RunnerSalaryRate", {
                      attrs: { rate: o?.extra_options?.salary_rate ?? 0 },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "comment_block" }, [
                  _c(
                    "div",
                    [
                      _vm._l(
                        o.extra_options?.comments_for_runner ?? [],
                        function (comment) {
                          return [
                            _c("p", {
                              domProps: { innerHTML: _vm._s(comment.text) },
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "comment_author_date" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.moment(comment.created_at, "DD.MM HH:mm")
                                )
                              ),
                            ]),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm._l(o.comment ?? [], function (comment) {
                        return [
                          _c("p", {
                            domProps: { innerHTML: _vm._s(comment.text) },
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "comment_author_date" }, [
                            _vm._v(
                              _vm._s(
                                _vm.moment(comment.created_at, "DD.MM HH:mm")
                              )
                            ),
                          ]),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-1 mb-1 flex justify-content-between" },
                    [
                      _c(
                        "v-popover",
                        {
                          attrs: {
                            "auto-hide": true,
                            popoverClass: "reject_reason_popover",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-xs btn-outline-info",
                              attrs: { type: "button" },
                            },
                            [
                              _vm._v(
                                "\n              Вопрос менеджеру\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("template", { slot: "popover" }, [
                            _c(
                              "div",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: o.manager_request,
                                      expression: "o.manager_request",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Ваш вопрос",
                                  },
                                  domProps: { value: o.manager_request },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        o,
                                        "manager_request",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("LoadingButton", {
                                  attrs: {
                                    title: "Отправить",
                                    type: "button",
                                    className: "btn btn-xs btn-info",
                                    loading: _vm.updateBtnLoading,
                                    color: _vm.$constants.LOADING_COLOR,
                                    onClick: () =>
                                      _vm.updateOrderByAction(
                                        o,
                                        "addManagerRequest"
                                      ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "v-popover",
                        {
                          attrs: {
                            "auto-hide": true,
                            popoverClass: "reject_reason_popover",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-xs btn-outline-info",
                              attrs: { type: "button" },
                            },
                            [
                              _vm._v(
                                "\n              Добавить комментарий\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("template", { slot: "popover" }, [
                            _c(
                              "div",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: o.new_comment,
                                      expression: "o.new_comment",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Ваш комментарий",
                                  },
                                  domProps: { value: o.new_comment },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        o,
                                        "new_comment",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("LoadingButton", {
                                  attrs: {
                                    title: "Сохранить",
                                    className: "btn btn-xs btn-info",
                                    loading: _vm.updateBtnLoading,
                                    color: _vm.$constants.LOADING_COLOR,
                                    onClick: () =>
                                      _vm.updateOrderByAction(o, "addComment"),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-1 mb-1" },
                    [
                      _c("UploadFile", {
                        attrs: { "order-id": o.id, type: "runnersFile" },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: `tr_status_${_vm.storeStatusByOrders[o.id]?.status}`,
                  },
                  [
                    _c(
                      "table",
                      { staticClass: "table mt-0 table-sm" },
                      [
                        _vm._l(o.details, function (d) {
                          return _c("tr", [
                            _c("td", [
                              _vm._v(
                                _vm._s(d.new_drug.title) + "\n              "
                              ),
                              _c("div", { staticClass: "flex flex_gap" }, [
                                _c(
                                  "span",
                                  [
                                    _c(
                                      "v-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          delay: { show: 100, hide: 100 },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "icon-fa icon-fa-image pointer",
                                          on: {
                                            click: function ($event) {
                                              return _vm.loadDrugImage(
                                                d.drug_id,
                                                o.site_id
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("template", { slot: "popover" }, [
                                          _c(
                                            "div",
                                            [
                                              _c("clip-loader", {
                                                attrs: {
                                                  loading:
                                                    _vm.imageLoading[d.drug_id],
                                                  color:
                                                    _vm.$constants
                                                      .LOADING_COLOR,
                                                  size: "20px",
                                                },
                                              }),
                                              _vm._v(" "),
                                              !_vm.imageLoading[d.drug_id]
                                                ? [
                                                    _vm.drugImages?.[
                                                      d.drug_id
                                                    ]?.[o.site_id]
                                                      ? _c("div", [
                                                          _c("img", {
                                                            attrs: {
                                                              src: _vm
                                                                .drugImages[
                                                                d.drug_id
                                                              ][o.site_id]
                                                                .image,
                                                            },
                                                          }),
                                                        ])
                                                      : _c("div", [
                                                          _vm._v(
                                                            "\n                            Фото не найдено\n                          "
                                                          ),
                                                        ]),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                d.new_drug.cool
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "alert cool_condition m-0",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Доставка с хладогеном\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              +d.new_drug.pack_set !== 1
                                ? _c("div", [
                                    _c("p", [_vm._v("препарат комплектный")]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "1компл. = " +
                                          _vm._s(+d.new_drug.pack_set) +
                                          "уп."
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("td", { attrs: { align: "right" } }, [
                              _c("strong", [
                                _vm._v(
                                  " x " +
                                    _vm._s(d.qty / (d.new_drug.pack_set || 1))
                                ),
                                +d.new_drug.pack_set !== 1
                                  ? _c("span", [_vm._v(" к.")])
                                  : _vm._e(),
                              ]),
                            ]),
                          ])
                        }),
                        _vm._v(" "),
                        _c(
                          "tr",
                          [
                            o.pay_method === 3
                              ? [_vm._m(0, true)]
                              : [
                                  _c(
                                    "td",
                                    { attrs: { colspan: "1" } },
                                    [
                                      _c("FastCallBackRequest", {
                                        attrs: { order: o },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "price_td",
                                      attrs: { align: "right" },
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.showCurrencyPrices
                                              ? o.currency_id_price
                                              : o.price
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        ),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex justify-content-between" }, [
                  _c(
                    "div",
                    [
                      _vm.selectedRunner
                        ? [
                            _c("label", [
                              _c("input", {
                                attrs: { type: "checkbox" },
                                on: {
                                  change: (e) => _vm.updateSelectedOrders(e, o),
                                },
                              }),
                              _vm._v(" выбрать заявку\n            "),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.runnerId
                        ? [
                            _c("LoadingButton", {
                              attrs: {
                                title: "сбросить заявку",
                                className: "btn btn-xs btn-outline-info",
                                loading: _vm.btnLoading,
                                color: _vm.$constants.LOADING_COLOR,
                                onClick: () => _vm.resetOrders(o),
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "v-popover",
                        {
                          attrs: {
                            "auto-hide": true,
                            popoverClass: "reject_reason_popover",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-xs btn-outline-warning",
                              attrs: { type: "button" },
                            },
                            [_vm._v("\n              Отменить\n            ")]
                          ),
                          _vm._v(" "),
                          _c("template", { slot: "popover" }, [
                            _c(
                              "div",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: o.reject_reason,
                                      expression: "o.reject_reason",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Причина отказа",
                                  },
                                  domProps: { value: o.reject_reason },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        o,
                                        "reject_reason",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("LoadingButton", {
                                  attrs: {
                                    title: "Подтвердить",
                                    className: "btn btn-xs btn-warning",
                                    loading: _vm.updateBtnLoading,
                                    color: _vm.$constants.LOADING_COLOR,
                                    onClick: () => _vm.rejectOrder(o),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.runnerId
                        ? _c("LoadingButton", {
                            attrs: {
                              title: "Доставить",
                              className: "ml-1 btn btn-xs btn-success",
                              loading: _vm.btnLoading,
                              color: _vm.$constants.LOADING_COLOR,
                              onClick: () => _vm.setClosed(o),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ])
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      { staticClass: "price_td", attrs: { colspan: "2", align: "right" } },
      [_c("strong", [_vm._v("Заявка оплачена")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }